import { prepareChessboard, restrictMove, validateMove, showMagnus, loadNextConfiguration } from "../../utils";
import ChessBoard from "../../components/chessBoard";
import $ from 'jquery';

/**
 * @name lesson17Activity1
 * @function
 * @param { config }
 * @description: Pins, Forks, Skewers
 */

export function lesson17Activity1(config) {
    let position = config.position,
        next = config.next,
        finalPosition = config.resultFen,
        message = config.magnusMessage,
        wrongMessage = config.magnusWrongMessage,
        count = 2;

    let afterLoad = function () {
        prepareChessboard(config);
    }

    let onDragStart = function (source, piece, position, orientation) {
        return restrictMove(piece, config.restrictMoveOf);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        return validateMove(source, target, piece, false);
    }

    var onSnapEnd = function (source, target, piece) {
        let boardFen = ChessBoard.board.fen();
        --count;
        if (boardFen === finalPosition) {
            showMagnus({
                data: `Nice job!`,
                position: 'left',
                styleClass: 'xs'
            });
            loadNextConfiguration(4000, next, true)
        } else if (count > 0) {
            showMagnus({
                data: message,
                position: 'left',
                styleClass: 'xl'
            })
            setTimeout(function () {
                $(document).trigger('bubble-hide');
            }, 3000)
            ChessBoard.board.position(position);
            ChessBoard.game = new window.Chess(position + config.initialMoveOf);
        } else {
            ChessBoard.board.position(position);
            showMagnus({
                data: wrongMessage,
                position: 'left',
                styleClass: 'lg'
            })
            setTimeout(function () {
                ChessBoard.board.move(`${config.from}-${config.to}`);
            }, 2000)
            loadNextConfiguration(6000, next, false);
        }
    }


    const chessConfig = {
        config: {
            sparePieces: true,
            draggable: true,
            position: position,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            moveSpeed: 1000
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson17Activity2
 * @function
 * @param { config }
 * @description: chessboard related task
 */

export function lesson17Activity2(config) {
    let body = '<button class="repeat-btn-qa" type="button">Repeat Move</button>';

    let afterLoad = function () {
        prepareChessboard(config);
        if ($('.repeat-btn-qa').length === 0) {
            $('.right-box-content').append(body);
        }
        if ($('.repeat-btn-qa').length >= 2) {
            $('.repeat-btn-qa').remove();
        }
        $(function () {
            $('.answer').click(function () {
                clearTimeout(timer);
                clearTimeout(repeatTimer);
                $('.repeat-btn-qa').css('opacity', '0');
                setTimeout(function () {
                    $('.repeat-btn-qa').remove();
                }, 4000)
            })
        })

        let repeatTimer = setTimeout(function () {
            $('.repeat-btn-qa').click(function () {
                ChessBoard.board.position(config.position);
                setTimeout(function () {
                    ChessBoard.board.move(`${config.from}-${config.to}`);
                }, 2000)
            })
        }, 3000)

        $('.next-btn-container #next').click(function () {
            clearTimeout(timer);
            clearTimeout(repeatTimer);
            $('.repeat-btn-qa').remove();
        });
        $('.back-btn-container #previous').click(function () {
            clearTimeout(timer);
            clearTimeout(repeatTimer);
            $('.repeat-btn-qa').remove();
        })

        let timer = setTimeout(function () {
            $('.repeat-btn-qa').css('cursor', 'pointer');
            ChessBoard.board.move(`${config.from}-${config.to}`);
        }, 3000);
    }
    const chessConfig = {
        config: {
            position: config.position,
            moveSpeed: 1000
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}

/**
 * @name lesson17Activity3
 * @function
 * @param { config }
 * @description: Pins, Forks, Skewers
 */

export function lesson17Activity3(config) {
    let position = config.position,
        next = config.next,
        finalPosition = config.resultFen,
        message = config.magnusMessage,
        wrongMessage = config.magnusWrongMessage,
        count = 2;

    let afterLoad = function () {
        prepareChessboard(config);
    }

    let onDragStart = function (source, piece, position, orientation) {
        return restrictMove(piece, config.restrictMoveOf);
    }

    let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
        return validateMove(source, target, piece, false);
    }

    var onSnapEnd = function (source, target, piece) {
        let boardFen = ChessBoard.board.fen();
        --count;
        if (finalPosition.includes(boardFen)) {
            showMagnus({
                data: `Nice job!`,
                position: 'left',
                styleClass: 'xs'
            });
            loadNextConfiguration(4000, next, true)
        } else if (count > 0) {
            showMagnus({
                data: message,
                position: 'left',
                styleClass: 'xl'
            })
            setTimeout(function () {
                $(document).trigger('bubble-hide');
            }, 3000)
            ChessBoard.board.position(position);
            ChessBoard.game = new window.Chess(position + config.initialMoveOf);
        } else {
            ChessBoard.board.position(position);
            showMagnus({
                data: wrongMessage,
                position: 'left',
                styleClass: 'lg'
            })
            setTimeout(function () {
                ChessBoard.board.move(`${config.from}-${config.to}`);
            }, 2000)
            loadNextConfiguration(6000, next, false);
        }
    }


    const chessConfig = {
        config: {
            sparePieces: true,
            draggable: true,
            position: position,
            onDragStart: onDragStart,
            onDrop: onDrop,
            onSnapEnd: onSnapEnd,
            moveSpeed: 1000
        },
        afterLoad: afterLoad
    }
    return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_17/assignments.js